import { Button, ButtonProps, Link, LinkProps } from '@carto/meridian-ds/components'
import settings from 'settings'

const { documentationUrl } = settings

export default function DocLink({
  docUrl = '',
  children,
  useButton = false,
  baseUrl = documentationUrl,
  ...props
}: (LinkProps | ButtonProps) & { docUrl?: string; baseUrl?: string }) {
  if (useButton) {
    return (
      <Button variant="text" color="primary" href={`${baseUrl}${docUrl}`} external {...props}>
        {children}
      </Button>
    )
  }

  return (
    <Link href={`${baseUrl}${docUrl}`} external {...props}>
      {children}
    </Link>
  )
}
